import {trimQuery} from "./utils";

export type AggregationProps = {
  name: string
}

export const aggregations = (aggregations: Array<string>): string => {
  const aggs = aggregations.map(aggregation => `${trimQuery(aggregation)}`);
  return `
    aggs: [
      ${aggs.join('\n,')}
    ]
  `;
};
